import { useTranslation } from "react-i18next";

interface QuoteCardProps {
  quote: string;
  attribution: string;
}

export function Testimonials() {
  const { t } = useTranslation();

  const quotes = t("landing.testimonials.quotes", {
    returnObjects: true,
  }) as unknown as string[];

  const attribution = t("landing.testimonials.attribution");

  return (
    <section
      aria-labelledby="testimonials-title"
      className="border-b border-[var(--color-line)] bg-[var(--color-page-soft)] py-14 md:py-20"
    >
      <div className="page-container">
        <h2
          id="testimonials-title"
          className="text-[36px] font-bold leading-[1.05] tracking-[0] text-[var(--color-ink-strong)] md:text-[52px]"
        >
          {t("landing.testimonials.title")}
        </h2>
        <p className="mt-5 max-w-[64ch] text-[16px] leading-7 text-[var(--color-text)]">
          {t("landing.testimonials.body")}
        </p>
      </div>

      <div
        className="marquee-viewport relative mt-12 w-full overflow-hidden py-4"
        role="region"
        aria-label={t("landing.testimonials.title")}
      >
        <div className="page-container overflow-visible">
          <div className="marquee-track flex w-max gap-4 md:gap-6">
          {/* render the list twice for a seamless marquee loop */}
          {[...quotes, ...quotes].map((quote: string, index: number) => (
            <QuoteCard
              key={`${index}-${quote.slice(0, 12)}`}
              quote={quote}
              attribution={attribution}
            />
          ))}
          </div>
        </div>
        <div className="pointer-events-none absolute inset-y-0 left-0 w-24 bg-gradient-to-r from-[var(--color-page-soft)] to-transparent" />
        <div className="pointer-events-none absolute inset-y-0 right-0 w-24 bg-gradient-to-l from-[var(--color-page-soft)] to-transparent" />
      </div>
    </section>
  );
}

function QuoteCard({ quote, attribution }: QuoteCardProps) {
  return (
    <article className="lift flex w-[min(78vw,360px)] flex-shrink-0 flex-col gap-4 rounded-[var(--radius-xl)] border border-[var(--color-line)] bg-[var(--color-panel)] p-5 shadow-[0_12px_36px_rgba(60,41,112,0.07)] md:w-[440px] md:p-6">
      <p className="text-[15px] font-medium leading-7 text-[var(--color-text)] md:text-[16px]">
        “{quote}”
      </p>
      <footer className="mt-auto border-t border-[var(--color-line)] pt-4">
        <p className="text-[13px] font-bold tracking-[0] text-[var(--color-primary-deep)]">
          {attribution}
        </p>
      </footer>
    </article>
  );
}
